import { Skeleton } from "@/components/ui";

export const QuestionnaireDetailDialogQuestionsSkeleton = () => (
  <div className="flex-1 overflow-y-auto space-y-2">
    {[...Array(5)].map((_, i) => (
      <div
        // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
        key={i}
        className="flex flex-col p-2 border border-neutral-300 rounded-lg space-y-2"
      >
        <Skeleton className="h-4 w-24" />
        <Skeleton className="h-5 w-full" />
        <Skeleton className="h-4 w-3/4" />
      </div>
    ))}
  </div>
);

export const QuestionnaireDetailDialogFooterSkeleton = () => (
  <div className="flex-shrink-0 space-y-3">
    <div className="flex items-center space-x-2">
      <Skeleton className="w-3 h-3 rounded-full" />
      <Skeleton className="h-3 w-48" />
    </div>
    <div className="flex flex-col space-y-2 p-3 bg-neutral-100 rounded-lg">
      <Skeleton className="h-4 w-20" />
      <Skeleton className="h-6 w-12" />
    </div>
  </div>
);
